export default __webpack_public_path__ + "static/rovo-multiple-indicators-light-8a264de404fde2c5b4bb8c43df043553fb50611ab3aa3ff575f8e5b3465eb037.png";